export default "__VITE_ASSET__C8ge7_sn__"